import { render, staticRenderFns } from "./ServicoEixoListFiltro.vue?vue&type=template&id=2252385a"
import script from "./ServicoEixoListFiltro.vue?vue&type=script&lang=js"
export * from "./ServicoEixoListFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports